import { anyPass, isNil, isEmpty } from 'ramda';

export default anyPass([isNil, isEmpty]);
